import request from '../utils/request.js'

/** 品城卡接口 */

/**
 * 分站全部品城卡
 * @param params
 * @returns {AxiosPromise}
 */
export function stationCards(params) {
  return request({
    url: '/api/station_card',
    method: 'get',
    params: params
  })
}

/**
 * 分站品城卡类型
 * @param params
 * @returns {AxiosPromise}
 */
export function stationCardTypes(stationId) {
  return request({
    url: `/api/station_card_shelf/list/${stationId}`,
    method: 'get'
  })
}

/**
 * 查询品城卡
 * @param params
 * @returns {AxiosPromise}
 */
export function cardList(params) {
  return request({
    url: '/api/card_shelf/list',
    method: 'get',
    params: params
  })
}

/**
 * 查询品城卡详情
 * @param params
 * @returns {AxiosPromise}
 */
export function cardShelfDetail(cardShelfId) {
  return request({
    url: `/api/card_shelf/${cardShelfId}`,
    method: 'get'
  })
}

/**
 * 保存品城卡
 * @param params
 * @returns {AxiosPromise}
 */
export function saveCard(params) {
  return request({
    url: '/api/card_shelf',
    method: 'post',
    data: params
  })
}

/**
 * 保存分站品城卡
 * @param params
 * @returns {AxiosPromise}
 */
export function saveStationCard(params) {
  return request({
    url: '/api/station_card_shelf',
    method: 'post',
    data: params
  })
}

/**
 * 解绑品城卡
 * @param params
 * @returns {AxiosPromise}
 */
export function delCard(userId) {
  return request({
    url: `/api/user/card/${userId}`,
    method: 'delete'
  })
}

/**
 * 品城卡申请订单（记录）
 * @param params
 * @returns {AxiosPromise}
 */
export function cardOrder(params) {
  return request({
    url: `/api/station_card_order/`,
    method: 'get',
    params: params
  })
}

/**
 * 拒绝分站申请
 * @param params
 * @returns {AxiosPromise}
 */
export function rejectSite(params) {
  return request({
    url: '​/api/station_apply/reject',
    method: 'post',
    data: params
  })
}

/**
 * 审核通过分站申请
 * @param params
 * @returns {AxiosPromise}
 */
export function resolveSite(params) {
  return request({
    url: '/api/station_apply/resolve',
    method: 'post',
    data: params
  })
}

/**
 * 全部分站
 * @param params
 * @returns {AxiosPromise}
 */
export function allStation(params) {
  return request({
    url: '/api/station',
    method: 'get',
    params: params
  })
}

/**
 * 保存分站
 * @param params
 * @returns {AxiosPromise}
 */
export function saveStation(params) {
  return request({
    url: '/api/station',
    method: 'post',
    data: params
  })
}

/**
 * 分站详情
 * @param params
 * @returns {AxiosPromise}
 */
export function stationDetail(stationId) {
  return request({
    url: `/api/station/${stationId}`,
    method: 'get'
  })
}

/**
 * 申请领卡
 * @param params
 * @returns {AxiosPromise}
 */
export function apl_card(params) {
  return request({
    url: `/api/station_card_order/`,
    method: 'post',
    data: params
  })
}

/**
 * 审核通过
 * @param params
 * @returns {AxiosPromise}
 */
export function passApl(params) {
  return request({
    url: '/api/station_card_order/resolve',
    method: 'post',
    data: params
  })
}

/**
 * 审核通过
 * @param params
 * @returns {AxiosPromise}
 */
export function refuseApl(params) {
  return request({
    url: '/api/station_card_order/reject',
    method: 'post',
    data: params
  })
}

/**
 * 批量切换
 * @param params
 * @returns {AxiosPromise}
 */
export function change_station(params) {
  return request({
    url: '/api/station_card/change_station',
    method: 'post',
    data: params
  })
}

/**
 * 文件解析
 * @param params
 * @returns {AxiosPromise}
 */
export function excel_analysis(params) {
  return request({
    url: '/api/station_card/excel_analysis',
    method: 'post',
    data: params
  })
}

/**
 * 分站品品城卡仓库
 * @param params
 * @returns {AxiosPromise}
 */
 export function cardStorageList(params) {
  return request({
    url: `/api/card_storage/list`,
    method: 'get',
    params: params
  })
}
/**
 * 追加库存
 * @param params
 * @returns {AxiosPromise}
 */
 export function addQuantity(params) {
  return request({
    url: `/api/card_storage/add_quantity`,
    method: 'post',
    data: params
  })
}



/**
 * 品城卡权益包搜索
 * @param params
 * @returns {AxiosPromise}
 */
export function getCardPackageGroup(params) {
  return request({
    url: `/api/card_package_group`,
    method: 'get',
    params: params
  })
}
/**
 * 品城卡权益包详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getCardPackageGroupId(id) {
  return request({
    url: `/api/card_package_group/${id}`,
    method: 'get'
  })
}
/**
 * 品城卡权益包保存
 * @param params
 * @returns {AxiosPromise}
 */
export function postCardPackageGroup(params) {
  return request({
    url: '/api/card_package_group',
    method: 'post',
    data: params
  })
}
/**
 * 品城卡权益包删除
 * @param params
 * @returns {AxiosPromise}
 */
export function delCardPackageGroup(userId) {
  return request({
    url: `/api/card_package_group/${userId}`,
    method: 'delete'
  })
}

/**
 * 品城卡权益包批次保存
 * @param params
 * @returns {AxiosPromise}
 */
export function postCardCouponShelf(params) {
  return request({
    url: '/api/card_coupon_shelf',
    method: 'post',
    data: params
  })
}
/**
 * 品城卡权益包批次删除
 * @param params
 * @returns {AxiosPromise}
 */
export function delCardCouponShelf(userId) {
  return request({
    url: `/api/card_coupon_shelf/${userId}`,
    method: 'delete'
  })
}
/**
 * 批量切换分站接口V2
 * @param params
 * @returns {AxiosPromise}
 */
export function change_station_V2(params) {
  return request({
    url: '/api/station_card/change_station_V2',
    method: 'post',
    data: params
  })
}
